/**
 * OSの分類を返す
 *
 * @function isOS
 * @return {String} windows/android/ios/mac/other
 *
 * Use
import isOS from './functions/_isDevice.js' // UserAgentをpc,sp,tabの形で返す
if(isOS === 'pc'){

}
 *
 */
const isOS = (function () {
  const userAgent = navigator.userAgent
  let os = 'other'

  if (userAgent.indexOf('Windows') !== -1) {
    os = 'windows'
  } else if (userAgent.indexOf('Android') !== -1) {
    os = 'android'
  } else if (
    userAgent.indexOf('iPhone') !== -1 ||
    userAgent.indexOf('iPad') !== -1 ||
    userAgent.indexOf('iPod') !== -1
  ) {
    os = 'ios'
  } else if (userAgent.indexOf('mac os x') !== -1) {
    os = 'mac'
  }

  // window.alert(userAgent)
  // window.alert(os)

  return os
})()

export default isOS
